import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogService } from 'src/app/services/dialogService/dialog-service';
import { LanguageService } from 'src/app/services/languageService/language.service';
import { SubscriberService } from 'src/app/services/subscriberService/subscriber.service';
import { UserService } from 'src/app/services/userService/user.service';
import { Profile, IProfile } from 'src/app/shared/profile.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.less']
})
export class ProfileComponent implements OnInit {
  private profile = new Profile();
  features = environment.features;
  options;
  constructor(public dialogRef: MatDialogRef<ProfileComponent>, @Inject(MAT_DIALOG_DATA) public data: IProfile, private languageService: LanguageService, private subscriberService: SubscriberService, private dialogService: DialogService, private userService: UserService) { }

  ngOnInit(): void {
    if (this.data) {
      this.options = [{
        image: "",
        icon: "fa fa-fw fa-user",
        name: "gen_profile_name",
        action: "changeProfileName"
      }, {
        image: "assets/images/avatars/avatar" + this.data.avatar + ".png",
        icon: "",
        name: "gen_change_avatar",
        action: "changeAvatar"
      }];

      if (this.userService.getUser()?.type == 0) {
        this.options.push({
          image: "",
          icon: "fas fa-fw fa-user-shield",
          name: "gen_rating_level",
          action: "changeParentalRating"
        })
      }

      this.options.push({
        image: "",
        icon: "fas fa-fw fa-globe",
        name: "gen_language",
        action: "changeLanguage"
      });

      if (this.features.hasPinProtection) {
        this.options.push({
          image: "",
          icon: "fas fa-fw fa-user-lock",
          name: "gen_pin_protection",
          action: "changePin"
        });
      }
    }
  }

  /** Function triggered when user selects an option  */
  doAction(option) {
    switch (option.action) {
      case "changeProfileName":
        this.dialogService.openInputDialog({
          icon: "fa fa-user",
          title: "gen_profile_name",
          confirm: "gen_save",
          cancel: "gen_cancel",
          type: "text",
          inputTitle: "gen_profile_name",
          returnType: "afterClosed",
          value: this.data.displayName,
          rules: {
            required: true
          }
        }).afterClosed().subscribe(resp => {
          if (resp?.value) {
            this.data.displayName = resp.value;
            this.subscriberService.editProfileNew(this.data).then((resp: any) => { });
          }
        })
        break;
      case "changeAvatar":
        this.dialogService.openAvatarsDialog({
          selected: this.data.avatar,
          avatars: this.profile.getAvatars()
        }).subscribe(resp => {
          if (resp >= 0) {
            this.data.avatar = resp;
            this.ngOnInit();
            this.subscriberService.editProfileNew(this.data).then((resp: any) => { });
          }
        })
        break;
      case "changeParentalRating":
        this.dialogService.openOptionsDialog({
          icon: "fas fa-user-shield",
          title: "gen_rating_level",
          options: this.profile.getParental(0),
          selected: this.data.rating,
          confirm: "gen_save",
          cancel: "gen_cancel"
        }).subscribe(resp => {
          if (resp?.id >= 0 && resp?.id != this.data.rating) {
            this.data.rating = resp?.id;
            this.subscriberService.editProfileNew(this.data).then((resp: any) => { });
          }
        })
        break;
      case "changeLanguage":
        this.dialogService.openOptionsDialog({
          icon: "fas fa-globe",
          title: "gen_language",
          options: this.languageService.getLanguages(),
          selected: this.data.language,
          confirm: "gen_save",
          cancel: "gen_cancel"
        }).subscribe(resp => {
          if (resp) {
            this.data.language = resp;
            this.subscriberService.editProfileNew(this.data).then((resp: any) => { });
          }
        })
        break;
      case "changePin":
        this.dialogService.openInputDialog({
          title: "gen_pin_protection",
          message: "gen_pin_validation_rules",
          confirm: "gen_save",
          cancel: "gen_cancel",
          type: "password",
          inputTitle: "PIN",
          returnType: "afterClosed",
          toggle: {
            title: "gen_pin_protection",
            value: this.data.pinEnabled
          },
          rules: {
            regex: "[0-9]{5,5}",
            required: this.data.pinEnabled
          }
        }).afterClosed().subscribe(resp => {
          if (resp) {
            this.data.pinEnabled = resp.toogle;

            if (resp?.value) {
              this.data.pin = resp.value;
            } else {
              delete this.data.pin;
            }
            this.subscriberService.editProfileNew(this.data).then((resp: any) => { });
          }
        });
        break;
    }
  }
}